import { z, toJSONSchema } from 'zod';
import { useServiceRef } from 'hooks/useServiceRef';
import { ProductService } from '@services/product';
import { InputSchema, ToolDescriptor, ToolResponse } from '@mcp-b/webmcp-types';

const schema = z.object({
  productId: z.string().describe('The ID of the product to get the details of.')
});

export const getProductDetailsTool: ToolDescriptor<z.infer<typeof schema>, ToolResponse> = {
  name: 'get_product_details',
  description: `Get the details of a product. Schema: ${JSON.stringify(schema.shape)}`,
  inputSchema: toJSONSchema(schema) as InputSchema,
  execute: async ({ productId }: z.infer<typeof schema>): Promise<ToolResponse> => {
    const productServiceRef = useServiceRef(ProductService);

    const productDetails = await productServiceRef.current.getProductData(productId);

    return {
      content: [ {
        type: 'text',
        text: `Found product details: ${JSON.stringify(productDetails)}.`,
      } ]
    };
  }
};
